import { OwcButton } from "@one/react";
// @ts-ignore
import { Variant } from "@one/web-components/dist/index.cjs.js";
import React from "react";
import { THEME } from "@digitallab/grid-common-frontend-components";
import { react18WorkaroundProps } from "../../../../utils/constants/react18WorkaroundProps";
import { FormSubmitButton } from "./FormSubmitButton";
import { useFormikContext } from "formik";

type Props = {
  confirmOnly: boolean;
  cancelText: string;
  onClose: (type: "resolve" | "reject") => void;
  children?: React.ReactNode;
  confirmButtonVariant: Variant;
  confirmText: string;
  type?: "dialog" | "form";
};
export const FormFooterWithButtons = ({
  confirmOnly,
  cancelText,
  onClose,
  children,
  confirmButtonVariant,
  confirmText,
  type
}: Props) =>
{
  const formik = useFormikContext();
  return (
    <div slot="footer" style={{ display: "flex", justifyContent: "flex-end", paddingTop: THEME["one-spacer-16"], paddingBottom: THEME["one-spacer-16"] }}>
      {!confirmOnly && (
        <OwcButton
          {...react18WorkaroundProps}
          style={{
            margin: 2,
            marginRight: THEME["one-spacer-12"]
          }}
          variant="secondary"
          onClick={() => onClose("reject")}
        >
          {cancelText}
        </OwcButton>
      )}
      {type === "form" ? (
        <FormSubmitButton
          confirmButtonVariant={confirmButtonVariant}
          confirmText={confirmText}
        />
      ) : (
        <OwcButton
          {...react18WorkaroundProps}
          style={{ margin: 2 }}
          variant={confirmButtonVariant}
          onClick={async (e: React.MouseEvent<HTMLOwcButtonElement>) => {
            onClose("resolve");
          }}
          disabled={formik && !formik?.isValid}
        >
          {confirmText}
        </OwcButton>
      )}
      {children}
    </div>
  );
}
